import {BaseUserFlow, UserFlowStep, UserFlowList} from './BaseUserFlow';
import {UserFlowType} from './UserFlowFacade';

export class AuthUserFlow extends BaseUserFlow {
  protected type = UserFlowType.Auth;

  /**
   * @inheritdoc
   */
  public setCurrentStep = (newStep: string) => {
    // Setting the current step will override the steps available so only
    // the step being set can be selected.
    if (`${UserFlowType.Auth}.${UserFlowStep.Guest}` === newStep) {
      this.setSteps([`${UserFlowType.Auth}.${UserFlowStep.None}`]);
    } else {
      this.setSteps([`${newStep}`]);
    }
    this.setStep(0);
    return this;
  };

  /**
   * @inheritdoc
   */
  public getCurrentStep = (): any => {
    return this.steps[this.getStep()] || `${this.type}.${UserFlowStep.None}`;
  };

  /**
   * Increments the value of this.step by 1.
   *
   * @returns New index position of this.steps.
   */
  public setNextStep() {
    // const guestWorkflowMode = this.getGuestWorkflowModeFlow();
    // if (null !== guestWorkflowMode) {
    //   this.setCurrentStep(`${this.type}.${guestWorkflowMode}`);
    // } else {
    this.setCurrentStep(`${this.type}.${UserFlowStep.None}`);
    // }

    this.setStep(0);
    return 0;
  }

  /**
   * @inheritdoc
   */
  public configure(): UserFlowList {
    const newSteps: UserFlowList = [`${UserFlowType.Auth}.${UserFlowStep.None}`];

    // Reset the step.
    this.setStep(0);

    return newSteps;
  }
}
